import { Controller } from "@hotwired/stimulus"
import { confirmDialog } from '../helpers/swal_helper';

export default class extends Controller {
  static values = {
    token: String
  }

  static targets = ["form", "actionType"]

  skip(event) {
    event.preventDefault();

    confirmDialog({
      title: "Are you sure?",
      text: "Clicking 'Skip' will not carry your current classes into the new year and you'll need to manually create new ones.",
      confirmButtonText: "Yes, Skip",
      cancelButtonText: "Cancel"
    }).then((confirmed) => {
      if (confirmed) {
        this.actionTypeTarget.value = "skip";
        this.formTarget.submit();
      }
    });
  }

  setNext() {
    this.actionTypeTarget.value = "next";
  }
}
